module.exports = __webpack_public_path__ + "files/9638d6b81f3fbdc3a03efd1be36786cd.svg";